<template>
  <div class="login_f_box">
    <div class="top_right_box1">
      <!-- 语言切换 -->
      <el-popover
          placement="bottom"
          popper-class="top_user lan_popover"
          width="70"
          v-model="visible_lan"
          trigger="click">
          <span slot="reference">
            <span class="lan_icon" v-if="v_lan=='ch' ">简体中文</span>
            <span class="lan_icon" v-else-if="v_lan=='jp' ">日本語</span>
            <span class="lan_icon" v-else>English</span>
            <i v-if="visible_lan" class="el-icon-caret-top u_r_icon2"></i>
            <i v-else class="el-icon-caret-bottom u_r_icon2"></i>
          </span>
          <div class="u_box">
            <div class="lan_list_item" @click="lang_fun('ch')">简体中文</div>
            <div class="lan_list_item" @click="lang_fun('en')">English</div>
            <div class="lan_list_item" @click="lang_fun('jp')">日本語</div>
          </div>
      </el-popover>
    </div>

    <div class="login">

      <div class="tit_top">
        <img src="../../assets/img/Logo.png" alt="">
      </div>
      
      <div class="login_body">
        <!-- 填写信息 -->
        <el-form
          class="form_box"
          label-position="top"
          :model="form"
          @submit.native.prevent
        >
          <el-form-item>
            <div class="form_tit">{{$t('main.text33')}}</div>
          </el-form-item>
          <el-form-item>
            <div class="form_tit2">{{$t('main.text678')}}</div>
          </el-form-item>

          <el-alert
            v-if="api_ok"
            :title="$t('main.text32')"
            type="success"
            show-icon
            class="succ_alert"
            :closable="false"
          >
          </el-alert>


          <el-form-item :label="$t('main.text185')">
            <el-input v-model.trim="form.email" @keyup.enter.native="confirm_btn"></el-input>
          </el-form-item>
          
          <el-form-item>
            <el-button class="login_btn" @click="confirm_btn">{{ $t("main.text36") }}</el-button>
          </el-form-item>
        </el-form>
        
        
      </div>
      
      <router-link to="/login">
        <div class="login_btm_text">
          {{$t('main.text38')}}
        </div>
      </router-link>
      

    </div>
  </div>

</template>

<script>
import {sendEmail} from '@/api/api'
import * as EmailValidator from 'email-validator';

export default {
  data() {
    return {
      form: {
        email:'',
      },
      reg_box:this.$route.query.reg_box,
      reset_pwd_box:this.$route.query.reset_pwd_box,
      
      visible_lan:false,
      api_ok:false,


    };
  },
  mounted() {
  },
  methods: {
   
    confirm_btn(){
      if(this.form.email==''){
        return this.message.ismessage('error',this.$t('main.text191'));
      }
      // 邮箱格式
      if (!EmailValidator.validate(this.form.email)) {
        return this.message.ismessage('error',this.$t('main.text453'));
      }

      sendEmail({
        email:this.form.email,
        type:"forgetLoginPassword"
      }).then(res=>{
        if (res.data.code==207) {
          this.api_ok=true;
          this.message.ismessage('success',res.data.msg);
        }else{
          this.message.ismessage('error',res.data.msg);
        }
      })
    },
   
    lang_fun(v) {
      localStorage.setItem("language", v);
      setTimeout(() => {
        location.reload();
      }, 100);
    },


  },
};
</script>

<style scoped>
.login_f_box{
  position: relative;
  width: 100%;
  min-height: 100vh;
  height: 100%;
  background: url(../../assets/img/forgot_pwd.png)  rgba(0, 0, 0, 1) no-repeat;
  background-size: cover;
  position: relative;
}
.login {
  position: absolute;
  width: 476px;
  min-height: 50%;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
}
.login_body{
  background: #232A36;
  border-radius: 16px;
  box-sizing: border-box;
  padding: 28px 28px 40px;
}
.tit_top{
  text-align: center;
}
.tit_top img{
  width: 80px;
  margin-bottom: 40px;
}
.login >>> .el-form--label-top .el-form-item__label{
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #BBBBBB;
}
.login >>> .el-input__inner{
  background: #333A47;
  border: 1.5px solid rgba(49, 72, 105, 0.1);
  border-radius: 4px;
  color: #fff;
}
.ewm_box{
  font-style: normal;
  font-weight: 700;
  text-align: center;
  color: #FFFFFF;
}
.ewm_box1{
  font-weight: 700;
  font-size: 22px;
  line-height: 26px;
  margin-bottom: 8px;
}
.ewm_box2{
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #BBBBBB;
  margin-bottom: 28px;
}
.ewm_box4{
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #BBBBBB;
  margin: 28px 0;
}
.ewm_ody{
  display: inline-block;
}
.login_btm_text{
  margin-top: 24px;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  text-decoration-line: underline;
  color: #00C18E;
}
.succ_alert{
  background: #BDC2CB;
  color: #191E29;
  margin-bottom: 28px;
  padding-top: 16px;
  padding-bottom: 16px;
}
.succ_alert >>> .el-alert__title{
  font-size: 15px;
}















.form_tit {
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  text-align: center;
  color: #FFFFFF;
}
.form_tit2{
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 20px;
  color: #FFFFFF;
  text-align: center;
  margin-top: 12px;
}
.for_pwd {
  text-align: right;
  color: #00C18E;
  font-size: 15px;
}
.for_pwd span{
  cursor: pointer;
  border-bottom: 1.5px solid #00C18E;
}
.code_w {
  display: flex;
}
.code_w2 {
  width: 60%;
}
.code_w3 {
  margin-left: 16px;
  border: 1.5px solid rgba(49, 72, 105, 0.1);
  border-radius: 4px;
  flex: 1;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-around;
  background: #333A47;
}
.code_w3 span {
  background: #000;
  height: 85%;
  line-height: 32px;
  border-radius: 5px;
  padding: 0 12px;
  font-size: 18px;
  display: inline-block;
  letter-spacing: 8px;
}
.login_btn,
.login_btn:hover {
  width: 100%;
  height: 42px;
  background: #00C18E;
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border-color: #00C18E;
  border-radius: 4px;
  color: #191E29;
  margin-top: 10px;
  font-size: 15px;
}

.f_icon {
  width: 18px;
  vertical-align: middle;
  /* margin-left: 10px; */
  cursor: pointer;
}
/* ------ */
.dlg_body{
    background: #041E35;
    color: #fff;  
}
.d_body{
    box-sizing: border-box;
    padding: 40px 0;
    max-width: 420px;
    margin: auto;
}
.dlg_u_box{
    display: flex;
    align-items: center;
}
.dlg_u1{
    width: 100px;
    height: 100px;
    border: 2px solid #DEB981;
    border-radius: 50%;
}
.dlg_u2,.dlg_u2:hover{
    background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
    box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
    border: none;
    border-radius: 4px;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    line-height: 18px;
    color: #04182A;
    margin-left: 40px;
    margin-bottom: 8px;
}
.dlg_u3{
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 18px;
    color: #FFFFFF;
    margin-left: 40px;
}
.dlg_form{
    margin-top: 25px;
}
.dlg_form >>> .el-form-item__label{
    line-height: 30px;
    color: #fff;
    padding: 0;
}
.cancel_btn{
    color: #F1C788;
    border-color: #F1C788;
    background: transparent;
}
.confirm_btn{
    background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
    box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
    border-radius: 4px;
    color: #04182A;
    border-color: #F1C788;
    margin-left: 20px;
}

.show-pwd {
  position: absolute;
  right: 10px;
  top: 1px;
  font-size: 16px;
  cursor: pointer;
  user-select: none;
}
.show-pwd img {
  width: 18px;
}
.login >>> .el-form-item {
  margin-bottom: 20px;
}

/* 语言切换 */
.lan_icon{
  width: 28px;
  height: 28px;
  vertical-align: middle;
  cursor: pointer;
  color: #00C18E;
}
.top_right_box1{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: absolute;
  top: 36px;
  right: 45px;
  z-index: 1;
}
.u_r_icon2{
  margin-left: 8px;
  cursor: pointer;
  margin-top: 5px;
  color: #fff;
  color: #00C18E;
}
.lan_list_item{
  cursor: pointer;
  /* width: 28px;
  height: 28px; */
  margin: 10px auto;
  display: block;
}
.head_title2{
  /* max-width: 70%; */
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.top_right_box1 > span{
  border: 1px solid rgba(49, 72, 105, 0.2);
  box-sizing: border-box;
  padding: 2px 6px;
  border-radius: 4px;
}



/* ------ */
</style>

<style>
/* 语言 */
.top_user{
  color: #fff;
  font-size: 15px;
  background: #03101C;
  box-shadow: 0px 4px 8px #03101C;
  border-radius: 16px;
  border: none;
}
.top_user[x-placement^=bottom] .popper__arrow,
.top_user[x-placement^=bottom] .popper__arrow::after{
  display: none;
  border-bottom-color: transparent;
}
.top_user .popper__arrow{
  display: none;
}
.lan_popover{
  min-width: 70px;
  /* transform: translateX(-12px); */
}
/* ---- */
</style>

<style scoped>
  /* 手机端 */
@media screen and (max-width: 850px) {
  .login{
    width: 100%;
  }
}
</style>

<style>
/* .dlg{
    background:rgb(4, 23, 40) !important;
    color: #fff;
} */
.dlg .el-dialog__title{
    color: #fff;
}
.dlg .el-dialog__headerbtn .el-dialog__close{
    color: #fff;
}
.dlg .el-dialog__body {
    padding: 30px 0;
}
</style>